import {grey} from "@mui/material/colors";
import {Popover} from "../../../../misc/Popover";
import React from "react";
import InfoIcon from "@mui/icons-material/Info";

export function InfoPopout(props: {
    value: string;
}) {
    const [hoverEl, setHoverEl] = React.useState<HTMLElement | null>(null);
    return (
        <>
            <div style={{fontSize: "0.8rem", height: "1em", overflow: "hidden", color: grey["800"]}} onClick={e => setHoverEl(e.currentTarget)}>
                <InfoIcon fontSize="inherit" />
            </div>
            {hoverEl && <Popover open={true} anchorEl={hoverEl} onClose={() => setHoverEl(null)}>
                <div style={{width: 250}}>
                    <div style={{padding: 15}}>
                        {props.value}
                    </div>
                </div>
            </Popover>}
        </>
    )
}